export default "__VITE_ASSET__e2b03b8e__"